import { formatDistance } from 'date-fns';
import { enUS, fr } from 'date-fns/locale';
import type { Locale } from 'date-fns';
import { formatDateTime } from './format-date-time';

export type RelativeLastSeenResult = {
  label: string;
  tooltip: string;
};

export function resolveDateFnsLocale(language: string): Locale {
  switch (language.split('-')[0]) {
    case 'fr':
      return fr;
    default:
      return enUS;
  }
}

export function formatRelativeLastSeen(
  value: string | Date | null | undefined,
  locale: Locale,
  now: Date = new Date(),
): RelativeLastSeenResult {
  if (!value) {
    return { label: '—', tooltip: '' };
  }

  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) {
    return { label: '—', tooltip: '' };
  }

  const label = formatDistance(date, now, { addSuffix: true, locale });
  const tooltip = formatDateTime(date.toISOString());

  return { label, tooltip };
}
